module.exports = __webpack_public_path__ + "0dd162fc445e1d17a5007460e0d08814.svg";